export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "localZones.worker.cb09ea700920a9fd7197.worker.js");
}
